import {
  QueryBuilderInputContextType,
  QueryBuilderTokenType,
} from '../../../../types';

export const getInputContext = (
  tokens: QueryBuilderTokenType[],
  activeTokenIndex: number | null = null
): QueryBuilderInputContextType => {
  if (activeTokenIndex !== null) {
    const activeToken = tokens[activeTokenIndex];

    if (activeToken?.type === 'entity') {
      return 'expectValue';
    }

    if (activeToken?.type === 'operator') {
      return 'expectOperatorOrClose';
    }
  }

  const lastToken = tokens[tokens.length - 1];

  if (!lastToken) {
    return 'expectOperand';
  }

  if (lastToken.type === 'entity') {
    return 'expectValue';
  }

  if (lastToken.type === 'entityValue') {
    return 'expectOperatorOrClose';
  }

  if (lastToken.type === 'bracket' && lastToken.bracket === 'CLOSE') {
    return 'expectOperatorOrClose';
  }

  return 'expectOperand';
};
